import React from 'react'
import FAQForm from './FAQForm'

const AddFaq = () => {
  return (
    <FAQForm title="Add Faq"/>
  )
}

export default AddFaq
